import React, { useState } from 'react';
import BookCard from './BookCard';
import BookDetailModal from './BookDetailModal';
import './BookGrid.css';

function BookGrid({ books, onBookUpdate }) {
  const [selectedBook, setSelectedBook] = useState(null);

  return (
    <>
      <div className="book-grid">
        {books.map(book => (
          <BookCard
            key={book.id}
            book={book}
            onClick={() => setSelectedBook(book)}
          />
        ))}
      </div>
      
      {selectedBook && (
        <BookDetailModal
          book={selectedBook}
          onClose={() => setSelectedBook(null)}
          onBookUpdate={onBookUpdate}
        />
      )}
    </>
  );
}

export default BookGrid;